// extracted by mini-css-extract-plugin
module.exports = {"wrap":"ChosenFilters_wrap__Gezvw","header":"ChosenFilters_header__1Nbgc","clearButton":"ChosenFilters_clearButton__aEToK","item":"ChosenFilters_item__1FUsv"};